import React from 'react';
import { IStyleProps, LottieAnimation } from '../LottieAnimation';
import whisk from './whisk.json';

export const LottieWhisk: React.FC<IStyleProps> = (props) => <LottieAnimation animationData={whisk} {...props} />;
